import React from "react";

const modifierMaxLimit = 2147483647;

export const ModalModifierSelection = ({
  filteredModifierGroups,
  modifiers,
  selectedModifiers,
  handleModifierChange,
  merchantColor,
}: any) => {
  const selectableModifierGroups = filteredModifierGroups.map((group: any) => ({
    ...group,
    modifiers: modifiers.filter((mod: any) => mod.groupId === group.id),
    isSingleSelection: group.minRequired === 1 && group.maxAllowed === 1,
  }));

  return (
    <div className="flex flex-col">
      {selectableModifierGroups.map((group: any) => (
        <ModifierGroup
          key={group.id}
          group={group}
          selectedModifiers={selectedModifiers}
          handleModifierChange={handleModifierChange}
          merchantColor={merchantColor}
        />
      ))}
    </div>
  );
};

const ModifierGroupHeader = ({ group }: any) => {
  const minMaxText = [
    group.minRequired > 0 ? `${group.minRequired} REQUIRED` : "",
    group.maxAllowed > group.minRequired && group.maxAllowed != modifierMaxLimit
      ? `${group.maxAllowed} MAXIMUM`
      : "",
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <div className="flex justify-between text-gray-500 mb-4">
      <div className="font-semibold text-[13px] text-[#727272]">
        {group.name.toUpperCase()}
      </div>
      {minMaxText && (
        <div className="font-normal text-[13px]">{minMaxText}</div>
      )}
    </div>
  );
};

const ModifierGroup = ({
  group,
  selectedModifiers,
  handleModifierChange,
  merchantColor,
}: any) => {
  const selectedCount = Array.isArray(selectedModifiers[group.id])
    ? selectedModifiers[group.id].length
    : selectedModifiers[group.id]
    ? 1
    : 0;
  const isMaxReached = selectedCount >= group.maxAllowed;

  return (
    <div className="mb-4">
      <ModifierGroupHeader group={group} />
      <div>
        {group.modifiers.map((modifier: any) => (
          <ModifierItem
            key={modifier.id}
            group={group}
            modifier={modifier}
            selectedModifiers={selectedModifiers}
            handleModifierChange={handleModifierChange}
            isMaxReached={isMaxReached}
            merchantColor={merchantColor}
          />
        ))}
      </div>
    </div>
  );
};

const ModifierItem = ({
  group,
  modifier,
  selectedModifiers,
  handleModifierChange,
  isMaxReached,
  merchantColor,
}: any) => {
  const isSelected = Array.isArray(selectedModifiers[group.id])
    ? selectedModifiers[group.id].some(
        (selected: any) => selected.id === modifier.id
      )
    : selectedModifiers[group.id]?.id === modifier.id;

  const isDisabled = !group.isSingleSelection && isMaxReached && !isSelected;

  return (
    <div
      key={modifier.id}
      className={`mb-4 border-b border-[#E5E5E5] pb-4 ${
        isDisabled ? "opacity-50" : ""
      }`}
    >
      <label className="flex items-center justify-between">
        <div className="flex items-center">
          {group.isSingleSelection ? (
            <ModifierRadioSelection
              group={group}
              modifier={modifier}
              selectedModifiers={selectedModifiers}
              handleModifierChange={handleModifierChange}
              merchantColor={merchantColor}
            />
          ) : (
            <ModifierCheckboxSelection
              group={group}
              modifier={modifier}
              selectedModifiers={selectedModifiers}
              handleModifierChange={handleModifierChange}
              isDisabled={isDisabled}
              merchantColor={merchantColor}
            />
          )}
          <span>{modifier.name}</span>
        </div>
        <span className="text-right font-normal text-[15px] text-[#727272] opacity-80">
          +${(modifier.price / 100).toFixed(2)}
        </span>
      </label>
    </div>
  );
};

const ModifierRadioSelection = ({
  group,
  modifier,
  selectedModifiers,
  handleModifierChange,
  merchantColor,
}: any) => {
  const isSelected = selectedModifiers[group.id]?.id === modifier.id;

  return (
    <input
      type="radio"
      name={group.id}
      value={modifier.id}
      checked={isSelected}
      onChange={() => handleModifierChange(group.id, modifier.id, true)}
      className="mr-2"
      style={{
        width: "20px",
        height: "20px",
        cursor: "pointer",
        accentColor: merchantColor,
      }}
    />
  );
};

const ModifierCheckboxSelection = ({
  group,
  modifier,
  selectedModifiers,
  handleModifierChange,
  isSingleSelection,
  isDisabled,
  merchantColor,
}: any) => {
  const selectedArray = selectedModifiers[group.id] || [];
  const isChecked = selectedArray.some(
    (selected: any) => selected.id === modifier.id
  );
  return (
    <input
      type="checkbox"
      name={group.id}
      value={modifier.id}
      checked={isChecked}
      onChange={() =>
        handleModifierChange(group.id, modifier.id, isSingleSelection)
      }
      disabled={isDisabled}
      className="mr-2"
      style={{
        width: "20px",
        height: "20px",
        cursor: "pointer",
        accentColor: merchantColor,
      }}
    />
  );
};
